import React from "react";
import Common_Banner from "../Common_Components/Common_Heading/Common_Banner/Common_Banner";
import RequirementData from "./Requirement_Data/Requirement_Data";
import ReadyToStart from "../Home/Ready_To_Start/Ready_To_Start";
import GlobalCareerCTA from "../Home/GlobalCareerCTA/GlobalCareerCTA";

function Job_Requirement() {
  return (
    <>
      <Common_Banner
        image="/assets/images/home/hero_city_buildings.jpg"
        title="Job Requirements"
        subtitle="Check eligibility criteria and requirements for overseas placements"
      />


      <RequirementData/>

         <ReadyToStart
        title="Check Your Eligibility"
        description="Not sure if you qualify? Contact us for a free consultation with our recruitment experts."
        buttonText="Get Your Assessment"
      />
        <GlobalCareerCTA />
    </>
  );
}

export default Job_Requirement;
